let copySource = {
    document: {
        title:'Punkte kaufen/Punkte verschenken'
    },
    headerNav:{
        logo:{
            alt:'Marriott Bonvoy',
            link:'https://www.marriott.com/default.mi'
        },
        home: {
            copy: 'Home',
            link: ''
        },
        buy: {
            copy:'Punkte kaufen',
            stLink: 'https://uat.ssogateway.points.com/v2/oidc/marriottoidc?ssoProduct=buy&language=de-DE&iscid=points_buy_cta_em_pr',
            link:'https://ssogateway.points.com/v2/oidc/marriottoidc?ssoProduct=buy&language=de-DE&iscid=points_buy_cta_em_pr'
        },
        gift: {
            copy:'Punkte verschenken',
            stLink: 'https://uat.ssogateway.points.com/v2/oidc/marriottoidc?ssoProduct=gift&language=de-DE&iscid=points_gift_cta_em_pr',
            link:'https://ssogateway.points.com/v2/oidc/marriottoidc?ssoProduct=gift&language=de-DE&iscid=points_gift_cta_em_pr'
        },
        multiply: {
            copy:'Punkte Vervielfachen',
            stLink: 'https://sso-uat.lxc.points.com/v2/oidc/marriottoidc?ssoProduct=multiply&language=de-DE&iscid=points_multiply_plp_web_ev',
            link:'https://ssogateway.points.com/v2/oidc/marriottoidc?ssoProduct=multiply&language=de-DE&iscid=points_multiply_plp_web_ev'
        },
        mr: {
            copy:'Marriott.com',
            link:'https://www.marriott.de/default.mi'
        },
    },
    hero: {
        lang: 'landing-de',
        headline: {
            lineOne: 'Punkte für spontanes Reisen',
            lineTwo: 'Jetzt kaufen, spontan reisen',
        },
        subHeadline : 'Wenn die Zeit gekommen ist, haben Sie die nötigen Punkte,\n um Ihre Inspiration umzusetzen. Ob es sich um einen\n interessanten Ausflug oder ein spontanes Erlebnis handelt,\n es gibt unzählige Ausflugsziele und Aktivitäten. Jetzt Punkte\n kaufen oder Punkte verschenken',
        alt:'Punkte sammeln und grenzenlos reisen. Buchen Sie Ihre ultimative Traumreise und übernachten Sie öfter mal anderswo. Mehr ist Trumpf in diesem Jahr – möglich machen es die Marriott Bonvoy®-Punkte.'
    },
    promo: {
        hero: {
            promoLang: 'promo-de',
            headline: "Wonders of More",
            body:"Get closer to your next vacation with a 50% bonus on purchases of 2,000 or more points October 6–13.",
        }
    },
    ctas:{
        buy:{
            imgAlt:'Innenansicht eines Hotelzimmers mit Blick auf die Stadt.',
            header:'Punkte kaufen',
            copy:'Ob Sie Ihren Aufenthalt um eine zusätzliche Übernachtung\n verlängern oder VIP-Zugang zu einer ausverkauften Show erhalten\n – kaufen Sie jetzt Punkte, damit Sie für alles gerüstet sind.',
            linkCopy:'PUNKTE KAUFEN',
            stLink: 'https://uat.ssogateway.points.com/v2/oidc/marriottoidc?ssoProduct=buy&language=de-DE&iscid=points_buy_cta_em_pr',
            link:'https://ssogateway.points.com/v2/oidc/marriottoidc?ssoProduct=buy&language=de-DE&iscid=points_buy_cta_em_pr'
        },
        gift:{
            imgAlt:'Hotelbalkon mit Pool und Meerblick.',
            header:'Punkte verschenken',
            copy:'Verschenken Sie Punkte an Freunde und Verwandte, damit sie sich\n auf den Weg machen können, wann und wohin sie wollen.',
            linkCopy:'PUNKTE VERSCHENKEN',
            stLink: 'https://uat.ssogateway.points.com/v2/oidc/marriottoidc?ssoProduct=gift&language=de-DE&iscid=points_gift_cta_em_pr',
            link:'https://ssogateway.points.com/v2/oidc/marriottoidc?ssoProduct=gift&language=de-DE&iscid=points_gift_cta_em_pr'
        },
        multiply:{
            imgAlt:'Hotel balcony with a pool overlooking the ocean.',
            header:'Punkte Vervielfachen',
            copy:'Sie haben kürzlich bei einem Aufenthalt Punkte gesammelt? Kaufen Sie bis zu 4 Mal mehr Punkte und Sie erhalten eine Ermäßigung, damit Sie Ihre nächste Reise noch mehr genießen können.',
            linkCopy:'PUNKTE KAUFEN UND SPAREN',
            stLink: 'https://sso-uat.lxc.points.com/v2/oidc/marriottoidc?ssoProduct=multiply&language=de-DE&iscid=points_multiply_plp_web_ev',
            link:'https://ssogateway.points.com/v2/oidc/marriottoidc?ssoProduct=multiply&language=de-DE&iscid=points_multiply_plp_web_ev'
        },
        membership:{
            imgAlt:'',
            imgSrc: './images/mr_rebrand_register_Placeholder.png',
            header: 'Werden Sie Mitglied',
            linkCopy: 'Join now',
            link: 'https://www.marriott.com/de/loyalty/createAccount/createAccountPage1.mi?enrollmentSourceCode=MSPV',
            copy: 'Dann winken Ihnen Mitgliedertarife, Punkte für kostenlose Übernachtungen und vieles mehr. Neue Mitglieder können dreißig (30) Tage nach der Anmeldung zum Marriott Bonvoy-Programm Punkte kaufen.'
        }
    },
    footer:{
        copyrightOne:'Diese Website wird von Points.com Inc. im Auftrag von Marriott International, Inc. für den Kauf von Marriott Bonvoy Points gemäß den Allgemeinen ',
        copyrightLinkTC: 'https://points-ebgt.s3.amazonaws.com/marriott/terms-conditions/bonvoy-terms-and-conditions-DE-DE.html',
        copyrightTwo:'Geschäftsbedingungen von Points.com Inc.',
        copyrightThree:' betrieben. Die Vergabe und Nutzung von Marriott Bonvoy Points im Zusammenhang mit einer Kauftransaktion unterliegt den ',
        copyrightLinkTwo: 'https://www.marriott.com/loyalty/terms/default.mi',
        copyrightFour:'Programmregeln',
        copyrightFive:' und der ',
        copyrightLinkThree: 'https://www.marriott.com/about/privacy.mi',
        copyrightSix:'Datenschutzrichtlinie von Marriott Bonvoy',
        copyrightSeven:'.',

        options: {
            de: "Deutsch",
            es: "Español",
            en:'English',
            fr: 'Français',
            it: 'Italiano',
            jp:'日本語',
            pt:'Português',
            ch:'国际'
        },
        footerbar:{
            logo: "./images/bonvoy_logo.png",
            grp1: "LUXUS",
            grp2: "PREMIUM",
            grp3: "SELECT",
            grp4: "MIDSCALE",
            grp5: "LÄNGERE AUFENTHALTE"
        },
        langIconSrc: './images/Icon-Globe.svg',
        langIconAlt: 'Deutsch',
        tracking:{
            doNotSell:{
                copy:'Meine personenbezogenen Daten nicht verkaufen',
                href:'https://www.marriott.com/about/ccpa/do-not-sell.mi'
            },
            prefs: {
                copy:'Tracking-Einstellungen',
                href:'https://consent-pref.trustarc.com/?layout=gdpr&type=marriottgdpr&site=marriottgdpr.com&action=notice&country=ca&locale=en&behavior=implied&irm=undefined&from=https://consent.trustarc.com/'
            }
        },
        terms:{
            copy:'Nutzungsbedingungen',
            href:'https://www.marriott.de/about/terms-of-use.mi'
        },
        programTerms:{
            copy:'Allgemeine Geschäftsbedingungen zum Programm',
            href:'https://www.marriott.de/loyalty/terms/default.mi'
        },
        privacy:{
            copy:'Datenschutzzentrum',
            href:'https://www.marriott.de/ueber/datenschutzerklarung-deutschland.mi'
        },
        accessibility:{
            copy:'Digitale Barrierefreiheit',
            href:'https://www.marriott.de/digital-accessibility.mi'
        },
        siteMap:{
            copy:'Sitemap',
            href:'https://www.marriott.de/sitemap.mi'
        },
        help:{
            copy:'Hilfe',
            href:'https://www.marriott.de/help/default.mi'
        },
    }
    
}

export default copySource
